import { render, staticRenderFns } from "./OrganizerSettingForm.vue?vue&type=template&id=e0884dda&scoped=true"
import script from "./OrganizerSettingForm.vue?vue&type=script&lang=js"
export * from "./OrganizerSettingForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizerSettingForm.vue?vue&type=style&index=0&id=e0884dda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0884dda",
  null
  
)

export default component.exports